import { render, staticRenderFns } from "./SurveyQuestionComponent.vue?vue&type=template&id=622bece2&scoped=true&"
import script from "./SurveyQuestionComponent.vue?vue&type=script&lang=js&"
export * from "./SurveyQuestionComponent.vue?vue&type=script&lang=js&"
import style0 from "./SurveyQuestionComponent.vue?vue&type=style&index=0&id=622bece2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622bece2",
  null
  
)

export default component.exports